// Cookie consent management utility functions

export enum ConsentStatus {
  PENDING = "pending",
  ACCEPTED = "accepted",
  DECLINED = "declined",
}

const CONSENT_KEY = "epopi_cookie_consent";
const CONSENT_TIMESTAMP_KEY = "epopi_cookie_consent_timestamp";

// Émis lorsqu'un choix de consentement est enregistré, pour permettre aux
// composants (ex. pop-up d'annonce) de réagir sans être masqués par la
// bannière cookies.
export const COOKIE_CONSENT_EVENT = "epopi-cookie-consent-changed";

export const hasConsentChoice = (): boolean => {
  const consent = localStorage.getItem(CONSENT_KEY);
  return (
    consent !== null &&
    (consent === ConsentStatus.ACCEPTED || consent === ConsentStatus.DECLINED)
  );
};

export const getConsentStatus = (): ConsentStatus => {
  const consent = localStorage.getItem(CONSENT_KEY);

  if (consent === ConsentStatus.ACCEPTED) {
    return ConsentStatus.ACCEPTED;
  } else if (consent === ConsentStatus.DECLINED) {
    return ConsentStatus.DECLINED;
  }

  return ConsentStatus.PENDING;
};

export const saveConsentChoice = (status: ConsentStatus): void => {
  localStorage.setItem(CONSENT_KEY, status);
  localStorage.setItem(CONSENT_TIMESTAMP_KEY, Date.now().toString());
  window.dispatchEvent(new Event(COOKIE_CONSENT_EVENT));
};

export const hasAcceptedCookies = (): boolean => {
  return getConsentStatus() === ConsentStatus.ACCEPTED;
};

export const hasDeclinedCookies = (): boolean => {
  return getConsentStatus() === ConsentStatus.DECLINED;
};

export const clearConsent = (): void => {
  localStorage.removeItem(CONSENT_KEY);
  localStorage.removeItem(CONSENT_TIMESTAMP_KEY);
};

export const getConsentTimestamp = (): number | null => {
  const timestamp = localStorage.getItem(CONSENT_TIMESTAMP_KEY);
  return timestamp ? parseInt(timestamp, 10) : null;
};

export const isConsentValid = (maxDays: number = 365): boolean => {
  const timestamp = getConsentTimestamp();
  if (!timestamp) return false;

  const now = Date.now();
  const maxAge = maxDays * 24 * 60 * 60 * 1000;

  return now - timestamp <= maxAge;
};
